import(/* webpackMode: "eager" */ "/app/src/app/faq-peatsense/page.tsx")